import { useState } from "react";
import { Star } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export const ReviewDialog = ({ booking, open, onOpenChange, onDone }) => {
  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      await api.post("/reviews", { property_id: booking.property_id, booking_id: booking.id, rating, comment });
      toast.success("Thanks for your review!");
      onOpenChange(false);
      onDone?.();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading">Rate {booking?.property_name}</DialogTitle>
        </DialogHeader>
        <div className="flex justify-center gap-2 py-2">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              data-testid={`review-star-${n}`}
              onMouseEnter={() => setHover(n)}
              onMouseLeave={() => setHover(0)}
              onClick={() => setRating(n)}
            >
              <Star size={34} weight={(hover || rating) >= n ? "fill" : "regular"} className="text-amber-500 transition-transform hover:scale-110" />
            </button>
          ))}
        </div>
        <Textarea data-testid="review-comment" value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Share your experience (optional)" className="rounded-xl" rows={4} />
        <Button data-testid="review-submit" onClick={submit} disabled={saving} className="w-full rounded-xl bg-primary hover:bg-green-900">
          {saving ? "Submitting..." : "Submit Review"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
